import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type WeeklyScheduleExceptionId = Branded<string, "WeeklyScheduleExceptionId">;

const {
    factory: weeklyScheduleExceptionIdFactory,
    assert: isWeeklyScheduleExceptionId,
    zodSchema: weeklyScheduleExceptionIdZodSchema,
} = genericId<WeeklyScheduleExceptionId>("weekly_schedule_exception__", {
    regexMatch: /^(business-hour-exception_|weekly_schedule_exception).*$/,
});

export {
    isWeeklyScheduleExceptionId,
    weeklyScheduleExceptionIdFactory,
    weeklyScheduleExceptionIdZodSchema,
};
export type { WeeklyScheduleExceptionId };
